import { render, staticRenderFns } from "./btn-group.vue?vue&type=template&id=76663ebc"
var script = {}
import style0 from "./btn-group.vue?vue&type=style&index=0&id=76663ebc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports